import React from 'react';
import { ContextualSaveBar } from '@shopify/polaris';

const SaveBarComponent = ({ saveAction, discardAction, saveLoading, discardLoading, message, disabled = false }) => {
    return (
        <ContextualSaveBar
            alignContentFlush
            message={message}
            saveAction={{
                disabled: disabled,
                loading: saveLoading,
                onAction: saveAction,
            }}
            discardAction={{
                loading: discardLoading,
                onAction: discardAction,
            }}
        />
    );
}

export default SaveBarComponent;